import apiService from '../baseApiService';

const listingService = {
    getListing: async (listingId) => {
        return await apiService.get(`/v1/listings/${listingId}`);
    },
};

export default listingService;
